<template>
  <a-modal
    class="client-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    :footer="null"
    :title="title"
    @cancel="$emit('onCancel')"
  >
    <a-form layout="horizontal" :form="form" style="margin-bottom: 90px">
      <!-- <a-form-item
	v-if="$store.state.user.role == 1 "
	  label="合作企业"
	  :colon="false"
	  :label-col="{span:5}"
	  :wrapper-col="{span:17}"
	>
	  <a-select
	    v-decorator="['company_id',{rules: [
	      { required: true, message: '请选择企业' },
	    ]}]"
	    placeholder="请选择企业"
	  >
	    <a-select-option
	      v-for="item in companyData"
	      :key="item.id"
	      :value="item.id"
	    >
	      {{ item.companyInfo.qichacha_name }}
	    </a-select-option>
	  </a-select>
	</a-form-item> -->

      <a-form-item
        label="资料使用场景"
        :colon="false"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 17 }"
      >
        <a-radio-group
          v-decorator="[
            'scene',
            {
              rules: [
                {
                  required: true,
                  message: '请指定资料使用场景',
                },
              ],
            },
          ]"
        >
          <a-radio :value="1">传统任务</a-radio>
          <a-radio :value="2">远程任务</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item
        label="调查问卷名称"
        :colon="false"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 17 }"
      >
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入问卷名称',
                },
              ],
            },
          ]"
          placeholder="请输入问卷名称"
        />
      </a-form-item>
      <a-form-item
        label="调查问卷目的"
        :colon="false"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 17 }"
      >
        <a-textarea
          v-decorator="[
            'aim',
            {
              rules: [
                {
                  required: true,
                  message: '请输入调查问卷目的',
                },
              ],
            },
          ]"
          placeholder="请输入调查问卷目的"
          :autoSize="{ minRows: 4 }"
        />
      </a-form-item>
      <a-form-item
        label="调查问卷题目"
        :colon="false"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 17 }"
      >
        <a-select
          v-decorator="[
            'question_ids',
            { rules: [{ required: true, message: '请选择调查问卷题目' }] },
          ]"
          placeholder="请选择调查问卷题目"
          mode="multiple"
          :filterOption="filterOption"
          showSearch
        >
          <a-select-option
            v-for="item in questionData"
            :key="item.id"
            :value="item.id"
          >
            {{item.id}}、{{ item.question }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="关联产品"
        :colon="false"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 17 }"
      >
        <a-select
          v-decorator="[
            'product_id',
            { rules: [{ required: true, message: '请选择关联产品' }] },
          ]"
          placeholder="请选择关联产品"
        >
          <a-select-option
            v-for="item in productData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.title }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <slot />
  </a-modal>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    questionData: {
      type: Array,
    },
  },
  data() {
    return {
      productData: [],
      companyData: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted() {
    // 获取产品
    this.getProduct();
    this.getCompanyList();
  },
  methods: {
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post("/Company/getCooperationCompanyList");
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
      }
    },

    // 获取合作企业
    async getProduct() {
      let result = await this.$http.post("/product/getList");
      if (result.data.status === 1) {
        this.productData = result.data.data.data_list;
      }
    },
    // 将输入的内容与显示的内容进行匹配
    filterOption(value, option) {
      return option.componentOptions.children[0].text.indexOf(value) >= 0;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
